// B12 / B-S23: Duplicate opens the quotation form on a copy of a saved quote, booked as a NEW
// version of the same quote number. The copy has no quoteVerId (so quotationRequest() calls
// saveQuotation, never updateQuotation); duplicateOf marks it so QuotationForm fills from it.
import moment from 'moment'

// what the user quoted; status, expiry, lost/won details and audit fields start fresh
const COPIED_FIELDS = [
  'sQuoteNo', 'opportunity', 'customer', 'mbpBranch', 'createdByDept',
  'productType', 'quoteGrade', 'productValue', 'internalValue', 'productQty',
  'notes', 'expectedOrderDate', 'reqDeliveryDate', 'chaseBy', 'quoteType'
]

export function buildQuoteDuplicate(source, versionNo, today = new Date()) {
  const copy = { duplicateOf: source.quoteVerId }
  COPIED_FIELDS.forEach(key => {
    if (source[key] !== undefined && source[key] !== null) copy[key] = source[key]
  })
  copy.quoteVerDate = moment(today).format('DD/MM/YYYY')
  if (versionNo) copy.versionNo = versionNo
  return copy
}

// a quoteToEdit the form should fill from: a saved version (Edit) or a duplicate
export function isQuoteCopy(quoteToEdit) {
  return !!(quoteToEdit && (quoteToEdit.quoteVerId || quoteToEdit.duplicateOf))
}

// reads the full saved quote (list rows carry only some fields) and the next version number
export function loadQuoteDuplicate(quotationService, row) {
  return quotationService.getQuotationInfo(row.quoteVerId).then(full => {
    const oppId = (full.opportunity && full.opportunity.oppId) ||
      (row.opportunity && row.opportunity.oppId)
    return quotationService
      .getVersionNumber(full.sQuoteNo || row.sQuoteNo, oppId)
      .then(versionNo => buildQuoteDuplicate(full, versionNo))
  })
}
